import React from 'react'
import * as Icon from 'react-feather';

export default function Artcircle() {
   
  return (
    
    <section class="services-area ptb-80 bg-f7fafd">
                <div class="container">
                    <div class="row h-100 justify-content-center align-items-center">
                        <div class="col-lg-6 col-md-12 services-content">
                            <div class="section-title">
                                <h2>The Art of Making Textiles</h2>
                                <div class="bar"></div>
                                <p>In response to the evolving demands of the market, we have continuously refined our production processes to enhance efficiency and responsiveness.</p>
                            </div>
    
                            <div class="row">
                                <div class="col-lg-6 col-md-6">
                                    <div class="box">
                                    <Icon.ShoppingBag />Eco-Procurement
                                        
                                    </div>
                                </div>
    
                                <div class="col-lg-6 col-md-6">
                                    <div class="box">
                                    <Icon.Globe /> Geo-Processing
                                        
                                    </div>
                                </div>
    
                                <div class="col-lg-6 col-md-6">
                                    <div class="box">
                                    <Icon.AlignCenter /> Skilled Weaving
                                        
                                    </div>
                                </div>
    
                                <div class="col-lg-6 col-md-6">
                                    <div class="box">
                                    <Icon.CheckSquare /> Quality Control
                                        
                                    </div>
                                </div>
    
                                <div class="col-lg-6 col-md-6">
                                    <div class="box">
                                    <Icon.CheckCircle /> Certified Processing
                                        
                                    </div>
                                </div>
    
                                <div class="col-lg-6 col-md-6">
                                    <div class="box">
                                    <Icon.Briefcase /> Crafting Excellence
                                        
                                    </div>
                                </div>
    
                                <div class="col-lg-6 col-md-6">
                                    <div class="box">
                                    <Icon.CloudSnow /> Sustainable Practices
                                        
                                    </div>
                                </div>
    
                                <div class="col-lg-6 col-md-6">
                                    <div class="box">
                                    <Icon.List /> Timely Delivery
                                    </div>
                                </div>
                            </div>
                        </div>
    
                        <div class="col-lg-6 col-md-12 services-right-image">
                            <img src="/img/process-1.png" class="wow fadeInDown" data-wow-delay="0.6s" alt="book-self"/>
                            <img src="/img/process-2.png" class="wow fadeInUp" data-wow-delay="0.6s" alt="box"/>
                            <img src="/img/process-3.png" class="wow fadeInLeft" data-wow-delay="0.6s" alt="chair"/>
                            <img src="/img/process-4.png" class="wow zoomIn" data-wow-delay="0.6s" alt="cloud"/>
                            <img src="/img/process-5.png" class="wow bounceIn" data-wow-delay="0.6s" alt="cup"/>
                            <img src="/img/process-6.png" class="wow fadeInDown" data-wow-delay="0.6s" alt="flower"/>
                            
                            <img src="/img/circle-shape.png" class="bg-image rotateme" alt="circle"/>
                            
                            <img src="/img/main-process.png" class="wow fadeInUp" data-wow-delay="0.6s" alt="main-pic"/>
                        </div>
                    </div>
                </div>
            </section>
    
  )
}
